import { render, staticRenderFns } from "./MenuHostingFinancial.vue?vue&type=template&id=00b396fa&"
import script from "./MenuHostingFinancial.vue?vue&type=script&lang=js&"
export * from "./MenuHostingFinancial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports